import { PipeTransform } from '@angular/core';
var GetValueType = /** @class */ (function () {
    function GetValueType() {
    }
    GetValueType.prototype.transform = function (orderProductService, companyId) {
        var productServiceCompany = orderProductService.item.productServiceCompanies.find(function (psc) { return psc.company.id === companyId; });
        return productServiceCompany.valueType.toUpperCase();
    };
    return GetValueType;
}());
export { GetValueType };
